import { Attributes, DateUtils, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";

@NeoModel
export default class HistoricalRealisedGainOrLossReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    public brokerAccount: string = "";

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.add(new Date(), { months: -3 });

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = new Date();

    public gainPercentageThreshold: number = 0;

    public lossPercentageThreshold: number = 0;

    protected addBusinessRules(rules: Validation.Rules<this>): void {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.startDate != null && c.endDate != null && c.startDate > c.endDate, TextConstants.Validation.StartDateBeforeEndDate);
    }
}